import AnalyticsTabs from './AnalyticsTabs';

import { DimensionType } from 'hooks/analytics';

interface DimensionToggleProps {
    value: DimensionType;
    onChange: (val: DimensionType) => void;
    isOwner: boolean;
}

const dimensions: { value: DimensionType; label: string; ownerOnly?: boolean }[] = [
    { value: 'all', label: 'All' },
    { value: 'program', label: 'Visa Program' },
    { value: 'country', label: 'Country of Origin' },
    { value: 'practitioner', label: 'Practitioner', ownerOnly: true },
];

const DimensionToggle = ({ value, onChange, isOwner }: DimensionToggleProps) => {
    const visible = dimensions.filter((dimension) => !dimension.ownerOnly || isOwner);

    return (
        <AnalyticsTabs
            ariaLabel="Conversion breakdown"
            selected={value}
            onChange={onChange}
            tabs={visible.map((dimension) => ({
                value: dimension.value,
                label: dimension.label,
            }))}
            sx={{ mb: 0 }}
        />
    );
};

export default DimensionToggle;
